ixModuleRouting("impactx.disposition", {
    "/dispositiondetail/:id": {
        template: "<ixa-disposition-detail></ixa-disposition-detail>",
        templateUrl: "shared/purchaserequest/statusdetaildialog.tmpl.html",
        process: "Disposition",
        controller: "DispositionCtrl",
        controllerAs: "statusCtrl",
        workspace: "shop",
    },
    "/dispositiondetail": {
        template: "<ixa-disposition-detail></ixa-disposition-detail>",
        templateUrl: "shared/purchaserequest/statusdetaildialog.tmpl.html",
        process: "Disposition",
        controller: "DispositionCtrl",
        controllerAs: "statusCtrl",
        workspace: "shop",
    },
    "/dispositionlist": {
        template: "<ixa-disposition-list></ixa-disposition-list>",
        templateUrl: "modules/disposition/templates/dispositionlist.html",
        process: "Disposition",
        controller: "DispositionListCtrl",
        controllerAs: "dispositionListCtrl",
        workspace: "shop",
    },
    "/dispositionusertemplatelist/:timestamp?": {
        template: "<ixa-disposition-user-template-list></ixa-disposition-user-template-list>",
        templateUrl:
            "modules/disposition/templates/dispositionusertemplatelist.html",
        controller: "DispositionUserTemplateListCtrl",
        controllerAs: "dispositionUserTemplateListCtrl",
        process: "HandleDispositionTemplate",
        workspace: "shop",
    },
    "/dispositionuserowntemplatelist/:timestamp?": {
        template: "<ixa-disposition-user-own-template-list></ixa-disposition-user-own-template-list>",
        templateUrl:
            "modules/disposition/templates/dispositionuserowntemplatelist.html",
        controller: "DispositionUserOwnTemplateListCtrl",
        controllerAs: "dispositionUserOwnTemplateListCtrl",
        process: "CreateDispositionTemplate",
        workspace: "shop",
    },
    "/dispositionwait": {
        template: "<ixa-disposition-wait-list></ixa-disposition-wait-list>",
        templateUrl: "modules/disposition/templates/dispositionwaitlist.html",
        controller: "DispositionWaitListCtrl",
        controllerAs: "dispositionWaitListCtrl",
        process: "ViewDispositionWait",
        workspace: "shop",
    },
    "/dispositiondone": {
        template: "<ixa-disposition-done-list></ixa-disposition-done-list>",
        templateUrl: "modules/disposition/templates/dispositiondonelist.html",
        controller: "DispositionDoneListCtrl",
        controllerAs: "dispositionDoneListCtrl",
        process: "ViewDispositionWait",
        workspace: "shop",
    },
});
